import TicketDetailsActivityLog from './TicketDetailsActivityLog';

export { TicketDetailsActivityLog };
export default TicketDetailsActivityLog;
